import { render } from "./PreordersTable.vue?vue&type=template&id=3fb60790&scoped=true"
import script from "./PreordersTable.vue?vue&type=script&lang=js"
export * from "./PreordersTable.vue?vue&type=script&lang=js"

import "./PreordersTable.vue?vue&type=style&index=0&id=3fb60790&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb60790"]])

export default __exports__